import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    flex: 1,
    display: 'flex',
    height: '100%',
    width: '100%',
    textAlign: 'center',
    flexDirection: 'row',
    color: theme.palette.text.secondary,
    overflow: 'auto',
  },
  textTitleCard: {
    fontWeight: 'bold',
  },
  paperSummaryAudit: {
    flexDirection: 'column',
  },
}))
